import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

/**
 * SmartNet: tema sempre claro.
 * Evita misturar classes `dark:` do Tailwind com a paleta SmartNet.
 */
export const setColorTheme = () => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, 'light');
  document.body.classList.remove('dark');
  document.documentElement.classList.remove('dark');
  document.documentElement.style.setProperty('color-scheme', 'light');
};
